export * from "./imgs";
export * from "./detail";
